// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"cdec7851","513":"c2fb6a74","703":"36975824","787":"0c3f432a"}[chunkId] + ".chunk.js";
};